module.exports = __webpack_public_path__ + "front/img/20220802_video.b6f04462.png";